import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { PlayNavStatus } from 'react/matchmaking/unified/header/NetplayNavStatus';

// The header's Play link carries LIVE, the set's state or the search clock on
// every page. The match dock, mounted on every page outside #page_content,
// fills the link's slots (react/layout/header/SiteHeader: one in the desktop
// nav, one in the phone switch), so it follows the store whether or not the
// netplay app is on the page.
export default function HeaderPlayStatus() {
	const [slots, setSlots] = useState([]);
	useEffect(() => {
		setSlots(Array.from(document.querySelectorAll('[data-netplay-status="play"]')));
	}, []);
	return (
		<React.Fragment>
			{slots.map((slot, index) => ReactDOM.createPortal(<PlayNavStatus />, slot, `play-${index}`))}
		</React.Fragment>
	);
}
